var exports = {
  "Os": "xe30f6088--aa61de--group",
  "wm": "xe30f6088--aa61de--logo",
  "QG": "xe30f6088--aa61de--tomobile",
  "KW": "xe30f6088--aa61de--age",
};

module.exports = exports;
